import { Box, Skeleton } from "@mui/material";
import { colors, spacing } from "../../../../assets/styles/tokens";

const SKELETON_CARDS = 5;

export default function LeadsMobileSkeleton() {
  return (
    <Box>
      {Array.from({ length: SKELETON_CARDS }).map((_, index) => (
        <Box key={index} sx={{ py: spacing.Spacing.xl.$value, borderBottom: `1px solid ${colors.GrayLightMode[100].$value}` }}>
          <Skeleton variant="text" width="55%" height={22} />
          <Skeleton variant="text" width="70%" height={18} />
          <Skeleton variant="rectangular" width="100%" height={24} sx={{ mt: spacing.Spacing.md1.$value, borderRadius: spacing.Radius.xs.$value }} />
          <Box sx={{ display: "flex", gap: spacing.Spacing["3xl"].$value, mt: spacing.Spacing.lg.$value }}>
            <Skeleton variant="text" width={80} height={18} />
            <Skeleton variant="text" width={100} height={18} />
          </Box>
        </Box>
      ))}
    </Box>
  );
}
